import { ButtonProps, Icon, Text } from "@ttc3k/trekker";
import { Flex, styled } from "styled-system/jsx";
import { buttonCardRecipe } from "./recipe";

type ButtonCardProps = {
  Icon: React.ForwardRefExoticComponent<
    Omit<React.SVGProps<SVGSVGElement>, "ref"> &
      React.RefAttributes<SVGSVGElement>
  >;
  title: string;
  description: string;
  onClick: () => void;
  isSelected?: boolean;
  buttonProps?: ButtonProps;
};

export const ButtonCard = ({
  Icon: IconElement,
  title,
  description,
  onClick,
  isSelected,
  buttonProps,
}: ButtonCardProps) => {
  const buttonCardClasses = buttonCardRecipe();

  return (
    <styled.button
      onClick={onClick}
      className={buttonCardClasses}
      {...(isSelected ? { "aria-selected": isSelected } : {})}
      type="button"
      {...buttonProps}
    >
      <Icon Element={IconElement} w="20px" h="20px" color="icon.mid" />
      <Flex flexDir="column" gap="100">
        <Text color={"text.dark"} visual={"bodySemiBold"}>
          {title}
        </Text>
        <Text color={"text.mid"} visual={"smallRegular"}>
          {description}
        </Text>
      </Flex>
    </styled.button>
  );
};
